import { Paginated } from "@/api/types";
import { QueryParams } from "@/api";
import { User } from "@/types/models/User.interface";

export interface UserSchoolResponse extends Paginated<School> {}

export interface School {
  id: number;
  pk: number;
  unique_id: string;
  name: string;
  school_type: string;
  nces_district_id: string | null;
  nces_school_id: string | null;
  date_modified: string;
  email_domains: string[];
  is_valid: boolean;
  sources: Source[];
  address: Address;
  licenses?: License[];
  soonest_expiration?: number | null;
  classrooms?: Classroom[];
  teachers?: Teacher[];
  students?: Student[];
  district?: District[];
  notes?: string;
  timezone: Timezone | {};
}

export interface District {
  unique_id: string;
  id: number;
  pk: number;
  name: string;
}

export interface Student {
  id: string;
  unique_id: string;
  user: Pick<User, "first_name" | "last_name">;
}

export interface Teacher {
  id: string;
  unique_id: string;
  user: Pick<User, "first_name" | "last_name">;
}

export interface Classroom {
  id: number;
  pk: number;
  unique_id: string;
  name: string;
}

export interface License {
  id: number;
  product: string;
  expiration_date: string;
}

export interface Source {
  id?: string;
  unique_id?: string;
  provider: string;
}

export interface Address {
  address1: string;
  address2: string;
  address3: string;
  city: string;
  country: string;
  id: number;
  state: string;
  zip_code: string;
}

export interface Timezone {
  id: number;
  name: string;
  alias: string;
  utc_offset: number;
  observes_dst: boolean;
  current_timezone: string;
}

export interface UserSchoolFilter extends QueryParams {
  page?: number;
  page_size?: number;
  include_classrooms?: boolean;
  include_district?: boolean;
  include_licenses?: boolean;
  sort?: string;
}

export const userSchoolFilterMock: UserSchoolFilter = {
  page: 1,
  page_size: 20,
  include_classrooms: false,
  include_district: false,
  include_licenses: false,
  sort: "name",
};

export const userSchoolResponseMock: UserSchoolResponse = {
  count: 1,
  results: [
    {
      id: 2000287771,
      pk: 2000287771,
      unique_id: "a33c0bca5ce94b15803b51eeb58c59f4",
      name: "Jujutsu school",
      school_type: "PU",
      nces_district_id: null,
      nces_school_id: null,
      date_modified: "2024-11-01T01:36:04Z",
      email_domains: [],
      is_valid: true,
      sources: [
        {
          provider: "oneroster",
        },
      ],
      address: {
        address1: "6440 Rhonda Hills",
        address2: "",
        address3: "",
        city: "West Lisaburgh",
        country: "US",
        id: 2000325259,
        state: "AL",
        zip_code: "36644",
      },
      timezone: {
        id: 1,
        alias: "CST",
        current_timezone: "America/Chicago",
        name: "America/Chicago",
        observes_dst: true,
        utc_offset: "-6",
      },
      licenses: [
        {
          id: 86,
          product: "essentials",
          expiration_date: "2025-01-30T06:35:40Z",
        },
        {
          id: 87,
          product: "science",
          expiration_date: "2025-01-30T06:35:40Z",
        },
      ],
      soonest_expiration: 77,
      classrooms: [
        {
          id: 1,
          pk: 1,
          name: "Classroom 1",
          unique_id: "fc1248csfhisve1",
        },
      ],
      district: [
        {
          unique_id: "fc1fc5a5a5784c9ba9213ee2ec5d4be5",
          id: 25127,
          pk: 25127,
          name: "Kaylee Sherman",
        },
      ],
    },
  ],
};
